import { MiVideoStill } from '../../cms/services/moving-image/moving-image'

export class ObjectUtils {

  static domParser = typeof window !== 'undefined' ? (new DOMParser()) : undefined

  static getInnerText (html: string): string {
    return ObjectUtils.domParser?.parseFromString(html ?? '<div></div>', 'text/html').body.innerText ?? ''
  }

  static setNestedProperty (object: object, path: string[], value: any): any {
    if (path.length === 1) {
      (object as any)[path[0]] = value
      return
    }
    return this.setNestedProperty((object as any)[path[0]], path.slice(1), value)
  }

  static getNestedProperty (object: object, path: string[]): any {
    if (path.length === 1) {
      return (object as any)[path[0]]
    }
    return this.getNestedProperty((object as any)[path[0]], path.slice(1))
  }

  static flatten (array: any[], key: string): any[] {
    const parents = [] as any[]
    const children = array.flatMap((item: any) => {
      if (Array.isArray(item[key]) && item[key]?.length) {
        parents.push(item)
        return this.flatten(item[key], key)
      }
      return item
    })
    return parents.concat(children, [])
  }

  static getClone (object: any): any {
    try {
      /* this could be replaced by structuredClone if we deem the browser support to be sufficient, as it is more
       * flexible in what it actually can clone, like functions, dates, RegEx etc. (which we currently do not support)
       */
      return JSON.parse(JSON.stringify(object))
    } catch (e) {
      return undefined
    }
  }

  static parseJSON (json: string): any {
    try {
      return JSON.parse(json)
    } catch (e) {
      return undefined
    }
  }

  static getCombinedImageUrl (url1: string, url2: string): string {
    return `${url1?.length ? url1 + ' 1x' : ''}${url2?.length ? ', ' + url2 + ' 2x' : ''}`
  }

  static getStillUrl (stills: MiVideoStill[], width: number): string {
    if (!stills?.length) {
      return ''
    }
    const sorted = stills.sort((s1, s2) => (s1?.dimension?.width ?? 0) - (s2?.dimension?.width ?? 0))
    return sorted.find(still => still?.dimension?.width ?? 0 > width)?.url || sorted[sorted.length - 1]?.url || ''
  }
}
